import { Injectable } from '@angular/core';
import { NgForm } from '@angular/forms';

@Injectable({
  providedIn: 'root',
})
export class DirtyFormRegistrationService {
  private readonly forms: Set<NgForm>;

  constructor() {
    this.forms = new Set<NgForm>();
  }

  isDirty(): boolean {
    let dirty = false;
    for (const form of this.forms) {
      if (form.dirty) {
        dirty = true;
        break;
      }
    }
    return dirty;
  }

  registerForm(form: NgForm | null | undefined) {
    if (form == null) {
      console.error('Trying to add form that is null or undefined');
      return;
    }
    this.forms.add(form);
  }

  deregisterForm(form: NgForm | null | undefined) {
    if (form == null) {
      console.error('Trying to delete form that is null or undefined');
      return;
    }
    this.forms.delete(form);
  }
}
